import {css} from '@emotion/css';
import React, {HTMLAttributes} from 'react';
import {theme} from './Common';
import {Page} from './Page';

export type PaginationProps = {
  totalPages: number;
  page: number | string;
  goToPage: (page: number) => unknown;
};
export const Pagination = ({totalPages, page, goToPage}: PaginationProps) => {
  if (!totalPages || !page) return null;
  page = typeof page === 'number' ? page : parseInt(page);
  const radius = 2;
  const startPage = Math.max(Math.min(page - radius, totalPages - radius * 2), 1);
  const endPage = Math.min(startPage + radius * 2, totalPages);
  const item = (i, index?) => (
    <Page key={index} page={i} isActive={page === i} onClick={() => goToPage(i)} />
  );
  const pages = [...Array(endPage - startPage + 1).keys()].map(i => i + startPage).map(item);
  return (
    <Container>
      {startPage > 1 && item(1)}
      {startPage > 2 && <Dots>...</Dots>}
      {pages}
      {endPage < totalPages - 1 && <Dots>...</Dots>}
      {endPage < totalPages && item(totalPages)}
    </Container>
  );
};
const Container = (args: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={css({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto',
      marginTop: theme.spacings.medium,
      gap: theme.spacings.xxsmall,
      [theme.mediaMaxWidth.medium]: {gap: `calc(${theme.spacings.xxsmall} / 2)`},
    })}
    {...args}
  />
);
const Dots = (args: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={css({
      color: theme.colors.darkGray,
      fontSize: theme.font.sizes.small,
      fontWeight: theme.font.normal,
      fontFamily: theme.font.family,
      margin: 0,
    })}
    {...args}
  />
);
